// PATH: src/routes/CurriculumGuard.tsx — onboarding « programme marocain ».
//
// Tant que l'établissement n'a pas choisi (mode ""), la direction est envoyée
// vers /programme. N'affecte JAMAIS les autres comptes (enseignants…), et
// laisse passer en cas d'échec de lecture : un incident réseau ne doit pas
// bloquer l'école. Les établissements déjà configurés ont été marqués
// « CUSTOM » par la migration : ils ne verront jamais cet écran.
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "../context/AuthContext";
import { useCurriculumApi, type CurriculumMode } from "../api/curriculum";

const CurriculumGuard: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isBusiness = useAuth().user?.userTypeCode === "BUSINESS";
  const api = useCurriculumApi();
  // undefined = lecture en cours ; null = lecture impossible (on laisse passer).
  const [mode, setMode] = useState<CurriculumMode | null | undefined>(isBusiness ? undefined : null);

  useEffect(() => {
    if (!isBusiness) return;
    let cancelled = false;
    api
      .get()
      .then((c) => { if (!cancelled) setMode(c.mode ?? ""); })
      .catch(() => { if (!cancelled) setMode(null); });
    return () => { cancelled = true; };
  }, [api, isBusiness]);

  if (!isBusiness) return children;

  if (mode === undefined) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (mode === "") return <Navigate to="/programme" replace />;

  return children;
};

export default CurriculumGuard;
